export enum UserRole {
    Employee = "Employee",
    Manager = "Manager",
    Administrator = "Administrator"
}